module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/t_i_laptop-8cac848662ee62e0b7c24b5a7ffe5e5a.png";